var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "error-page" },
    [
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c("b-col", [
                _c(
                  "div",
                  { staticClass: "error-details" },
                  [
                    _c("div", { staticClass: "error-code" }, [
                      _vm._v(
                        "\n            " + _vm._s(_vm.code) + "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "error-message" }, [
                      _vm._v(
                        "\n            " + _vm._s(_vm.message) + "\n          "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.code === 404
                      ? _c(
                          "b-btn",
                          {
                            staticClass: "reload-page",
                            attrs: { variant: "primary", size: "lg" },
                            on: { click: _vm.gotoHomepage },
                          },
                          [
                            _vm._v(
                              "\n            Return to the homepage\n          "
                            ),
                          ]
                        )
                      : _c(
                          "b-btn",
                          {
                            staticClass: "reload-page",
                            attrs: { variant: "primary", size: "lg" },
                            on: { click: _vm.reloadPage },
                          },
                          [_vm._v("\n            Reload Page\n          ")]
                        ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-container",
        [
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c("content-creator", {
                    attrs: {
                      settings: _vm.getBlobContents(`error-page-${_vm.code}`),
                      permissions: _vm.contentCreatorPermissions,
                      "is-visible": _vm.editContentCreator,
                      filestore: _vm.websitefilestore,
                      name: `error-page-${_vm.code}`,
                      "allowed-widgets": "content-grid, link-list",
                    },
                    on: {
                      updateBlob: (data) =>
                        _vm.saveBlob(`error-page-${_vm.code}`, data),
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }